export default "__VITE_ASSET__CkGKy$ld__"